import './lot-selection.scss';
import { AjaxLoader } from '../../utilities/js/ajax-load-promise.js';
import tippy from 'tippy.js';
require('../../assets/images/flares.svg');

class LotSelection {
    constructor () {
        this.$lotSelection = document.querySelector('[data-lot-selection="root"]');
        this.$lotTabs = [].slice.call(document.querySelectorAll('[data-lot-tab-id]'));
        this.$lotList = this.$lotSelection.querySelector('[data-lot-selection="lot-list"]');
        this.$lotSelector = this.$lotSelection.querySelector('[data-lot-selection="lot-selector"]');

        this.$form = this.$lotSelection.querySelector('[data-lot-selection="form"]');
        this.$ajaxURI = this.$form.getAttribute('data-action');

        this.$lotChangeAmount = [].slice.call(this.$lotSelection.querySelectorAll('[data-lot-selection-method]'));

        this.$activeLot = this.$lotSelection.querySelector('[data-lot-id].is--active');

        // Lot Footer Variables
        this.$lotSelectionFooter = this.$lotSelection.querySelector('[data-lot-selection="footer"]');
        this.$lotSelectionChance = this.$lotSelection.querySelector('[data-lot-selection="chance"]');
        this.$lotSelectionHitChance = this.$lotSelection.querySelector('[data-lot-selection="hitchance"]');
        this.$lotSelectionHitChanceProgress = this.$lotSelection.querySelector('[data-lot-selection="hitchance-progress"]');
        this.$lotSelectionWin = this.$lotSelection.querySelector('[data-lot-selection="win"]');
        this.$lotSelectionMoney = this.$lotSelection.querySelector('[data-lot-selection="money"]');
        this.$lotSelectionStake = this.$lotSelection.querySelector('[data-lot-selection="stake"]');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$lotTabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                if (!tab.classList.contains('is--active')) {
                    if (this.$activeLot) {
                        this.$activeLot.classList.add('is--inactive');
                        this.$lotSelection.querySelector('[data-lot-tab-id="' + this.$activeLot.getAttribute('data-lot-id') + '"]').classList.remove('is--active');
                        tab.classList.add('is--active');

                        setTimeout(() => {
                            const $newActiveLot = this.$lotList.querySelector('[data-lot-id="' + tab.getAttribute('data-lot-tab-id') + '"]');
                            this.$activeLot.classList.remove('is--active');
                            this.$activeLot.classList.remove('is--inactive');

                            $newActiveLot.classList.add('is--active');
                            this.$activeLot = $newActiveLot;
                        }, 350);
                    }
                }
            });
        });

        this.$lotChangeAmount.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const lotId = trigger.getAttribute('data-lot-id');
                const type = trigger.getAttribute('data-lot-type');
                const method = trigger.getAttribute('data-lot-selection-method');
                this.changeLotAmount(method, lotId, type, () => {
                    const result = AjaxLoader.getData(this.$form.getAttribute('data-action'), {
                        method: 'POST',
                        data: new FormData(this.$form)
                    });
                    this.setLotResult(result);
                });
            });
        });
    }

    setLotResult (result) {
        result.then((results) => {
            let timer = 0;

            results = JSON.parse(results.toString());
            if (results.stake !== '0,00 €' && results.stake !== '0,00\u00a0\u20ac') {
                if (!this.$lotSelectionFooter.classList.contains('is--visible')) {
                    timer = 350;
                    this.$lotSelectionFooter.style.height = this.$lotSelectionFooter.scrollHeight + 'px';
                    setTimeout(() => {
                        this.$lotSelectionFooter.style.height = 'auto';
                    }, 600);

                    this.$lotSelectionFooter.classList.add('is--visible');
                }
            } else {
                timer = 700;
                this.$lotSelectionFooter.style.height = this.$lotSelectionFooter.scrollHeight + 'px';
                setTimeout(() => {
                    this.$lotSelectionFooter.style.height = '';
                }, 600);
                this.$lotSelectionFooter.classList.remove('is--visible');
            }

            setTimeout(() => {
                if (results.hit_rate !== null) {
                    this.$lotSelectionChance.classList.remove('is--inactive');
                    const hitNumber = parseFloat(results.hit_rate);
                    if ((this.$lotSelectionHitChance.textContent !== results.hit_rate.toString() && hitNumber > parseFloat(this.$lotSelectionHitChance.textContent)) || this.$lotSelectionHitChance.textContent === '') {
                        this.$lotSelectionChance.classList.add('is--animated');
                        this.$lotSelectionHitChance.textContent = results.hit_rate.toString();
                        this.$lotSelectionHitChanceProgress.style.width = results.hit_rate.replace(',', '.');

                        setTimeout(() => {
                            this.$lotSelectionChance.classList.remove('is--animated');
                        }, 2000);
                    } else {
                        if (hitNumber <= parseFloat(this.$lotSelectionHitChance.textContent)) {
                            this.$lotSelectionHitChance.textContent = results.hit_rate.toString();
                            this.$lotSelectionHitChanceProgress.style.width = results.hit_rate.replace(',', '.');
                        }
                    }
                } else {
                    this.$lotSelectionChance.classList.add('is--inactive');
                    this.$lotSelectionHitChance.textContent = '';
                    this.$lotSelectionHitChanceProgress.style.width = '';
                    this.$lotSelectionChance.classList.remove('is--animated');
                }

                if (results.max_winning !== null) {
                    this.$lotSelectionWin.classList.remove('is--inactive');
                    if ((this.$lotSelectionMoney.textContent !== results.max_winning.toString() && parseInt(results.max_winning) > parseInt(this.$lotSelectionMoney.textContent)) || this.$lotSelectionMoney.textContent === '') {
                        this.$lotSelectionWin.classList.add('is--animated');
                        this.$lotSelectionMoney.textContent = results.max_winning.toString();

                        setTimeout(() => {
                            this.$lotSelectionWin.classList.remove('is--animated');
                        }, 2000);
                    } else {
                        if (parseInt(results.max_winning) <= parseInt(this.$lotSelectionMoney.textContent)) {
                            this.$lotSelectionMoney.textContent = results.max_winning.toString();
                        }
                    }
                } else {
                    this.$lotSelectionWin.classList.add('is--inactive');
                    this.$lotSelectionMoney.textContent = '';
                    this.$lotSelectionWin.classList.remove('is--animated');
                }

                if (results.stake !== null) {
                    this.$lotSelectionStake.textContent = results.stake.toString();
                }
            }, timer);
        });
    }

    changeLotAmount (method, lotId, type, callback) {
        const input = this.$lotSelection.querySelector('input[data-lot-id="' + lotId + '"]');
        const counter = this.$lotSelection.querySelector('[data-lot-selection-amount="' + type + '_' + lotId + '"]');
        const max = parseInt(input.getAttribute('data-max'));

        if (method === 'increase') {
            if ((parseInt(input.value) + 1) <= max) {
                input.value = parseInt(input.value) + 1;
                counter.classList.add('is--set');

                counter.textContent = input.value;

                if (typeof callback === 'function') {
                    callback();
                }
            } else {
                const content = counter.nextElementSibling.getAttribute('data-tippy-content');

                if (content !== null) {
                    const div = document.createElement('div');
                    div.classList.add('tooltip', 'is--orange');
                    div.innerHTML = '<div class="tooltip__box"><p>' + content + '</p></div>'.trim();

                    const buttonTippy = tippy(counter.nextElementSibling, {
                        arrow: '<span class="tooltip__arrow is--orange"></span>',
                        duration: [250, 250],
                        offset: [0, 15],
                        trigger: 'manual',
                        showOnCreate: true,
                        allowHTML: true,
                        animation: 'shift-away-subtle',
                        placement: 'bottom-end',
                        onCreate (instance) {
                            instance.setContent(div);
                        }
                    });
                    buttonTippy.show();

                    setTimeout(() => {
                        buttonTippy.hide();
                        buttonTippy.destroy();
                    }, 5000);
                }
            }
        }

        if (method === 'decrease' && input.value > 0) {
            input.value = parseInt(input.value) - 1;

            if (parseInt(input.value) === 0) {
                counter.classList.remove('is--set');
            }

            counter.textContent = input.value;

            if (typeof callback === 'function') {
                callback();
            }
        }
    }
}

export { LotSelection };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context.querySelector('[data-lot-selection="root"]')) {
        const $lotSelection = new LotSelection();
        $lotSelection.initialize();
    }
});
